export default function SettingsPage() {
  return <h1>Settings</h1>
} 